// Small inline SVG icons for the in-game voice controls (mic / speaker, with a slash when off).
import React from 'react';

const slash = (color) => (
  <line x1="3" y1="3" x2="21" y2="21" stroke={color} strokeWidth="2.4" strokeLinecap="round" />
);

export const MicIcon = ({ off = false, size = 18, color = '#fff', offColor = '#ff5252' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-label={off ? 'Mic muted' : 'Mic on'}>
    <path d="M12 2a3 3 0 00-3 3v6a3 3 0 106 0V5a3 3 0 00-3-3z" fill={off ? offColor : color} />
    <path d="M19 10v1a7 7 0 01-14 0v-1M12 18v4M8 22h8" stroke={off ? offColor : color} strokeWidth="2" strokeLinecap="round" />
    {off && slash(offColor)}
  </svg>
);

export const SpeakerIcon = ({ off = false, size = 18, color = '#fff', offColor = '#ff5252' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-label={off ? 'Speaker muted' : 'Speaker on'}>
    <path d="M3 9v6h4l5 4V5L7 9H3z" fill={off ? offColor : color} />
    {!off && <path d="M15.5 8.5a5 5 0 010 7M18 6a8.5 8.5 0 010 12" stroke={color} strokeWidth="2" strokeLinecap="round" />}
    {off && slash(offColor)}
  </svg>
);

export const MusicIcon = ({ off = false, size = 18, color = '#fff', offColor = '#ff5252' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-label={off ? 'Sound off' : 'Sound on'}>
    <path d="M9 18V5l11-2v13" stroke={off ? offColor : color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="6.5" cy="18" r="3" fill={off ? offColor : color} />
    <circle cx="17.5" cy="16" r="3" fill={off ? offColor : color} />
    {off && slash(offColor)}
  </svg>
);

export const PointsIcon = ({ size = 18, color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-label="Points table">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2" />
    <path d="M3 9h18M3 15h18M9 3v18" stroke={color} strokeWidth="1.6" />
  </svg>
);
